import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { useNavigation } from 'react-day-picker';

// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';

// Components
import { SelectMonth } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/components/Caption/SelectMonth';
import { SelectYear } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/components/Caption/SelectYear';
import { Navigation } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/components/Caption/Navigation';

// Types
import type { CaptionProps } from 'react-day-picker';

export function Caption({ displayMonth }: CaptionProps) {
    const { goToMonth } = useNavigation();
    const datepicker = useAtomValue(datepickerAtom);

    useEffect(() => {
        // Redirect to the current month of the date selected
        const dateToEvaluate = datepicker.mode === 'range' ? datepicker.date?.to : datepicker.date;

        if (dateToEvaluate) {
            goToMonth(dateToEvaluate);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datepicker.date]);

    return (
        <div className="mb-4 flex items-center justify-between px-3">
            <div className="flex items-center gap-2">
                <SelectMonth displayMonth={displayMonth} />
                <SelectYear displayMonth={displayMonth} />
            </div>
            <Navigation />
        </div>
    );
}
